const awsAccountFields = [
	{ "value": "aws_account_name", "label": "Account Name", requiredForInsert: true},
	{ "value": "account_name", "label": "Account Name", onlyForDisplay: true},
	{ "value": "hq_id", "label": "Country", requiredForInsert: true},
	{ "value": "hq", "label": "HQ", onlyForDisplay: true},
	{ "value": "subsidiaries", "label": "Subsidiaries"},
	{ "value": "address", "label": "Address"},
	{ "value": "employees", "label": "Employees"},
	{ "value": "linkedin_followers", "label": "LinkedIn Followers"},
	{ "value": "account_description", "label": "Account Description"},
	{ "value": "specialties", "label": "Specialties"},
	{ "value": "organization_type_id", "label": "Organization Type"},
	{ "value": "organization_type", "label": "Organization Type",onlyForDisplay: true},
	{ "value": "website", "label": "Website"},
	{ "value": "crunchbase_url", "label": "Crunchbase URL"},
	{ "value": "founded", "label": "Founded"},
	{ "value": "company_linkedin_id", "label": "Company LinkedIn ID"},
	{ "value": "city", "label": "City"},
	{ "value": "state_id", "label": "State"},
	{ "value": "state", "label": "State", onlyForDisplay: true},
	{ "value": "linkedin_url", "label": "LinkedIn URL"},
	{ "value": "logo", "label": "Logo"},
	{ "value": "similar_accounts", "label": "Similar Accounts"},
	{ "value": "updates", "label": "Updates"},
	{ "value": "slogan", "label": "Slogan"},
	{ "value": "affiliates", "label": "Affiliates"},
	{ "value": "funding", "label": "Funding"},
	{ "value": "investors", "label": "Investors"},
	{ "value": "us_district_id", "label": "US District"},
	{ "value": "us_district", "label": "US District", onlyForDisplay: true},
	{ "value": "decision_making", "label": "Decision Making"},
	{ "value": "presence", "label": "Presence"},
	{ "value": "installed_isv_technologies", "label": "Installed ISV Technologies"},
	{ "value": "installed_enterprise_technologies", "label": "Installed Enterprise Technologies"},
	{ "value": "installed_infra_providers", "label": "Installed Infra Providers"},
	{ "value": "installed_developer_tools", "label": "Installed Developer Tools"},
	{ "value": "aws_subsidiary_id", "label": "AWS subsidiary"},
	{ "value": "aws_segment_id", "label": "AWS Segment"},
	{ "value": "aws_segment", "label": "AWS Segment", onlyForDisplay: true},
	{ "value": "aws_sub_segment_id", "label": "AWS Sub-Segment"},
	{ "value": "aws_sub_segment", "label": "AWS Sub-Segment", onlyForDisplay: true},
	{ "value": "aws_partner_id", "label": "AWS Partner"},
	{ "value": "aws_partner_status", "label": "AWS Partner", onlyForDisplay: true},
	{ "value": "partner_type_id", "label": "Partner Type"},
	{ "value": "partner_type", "label": "Partner Type"},
	{ "value": "isv_accelerate_id", "label": "ISV Accelerate"},
	{ "value": "isv_accelerate", "label": "ISV Accelerate", onlyForDisplay: true},
	{ "value": "ace_eligible_id", "label": "ACE Eligible"},
	{ "value": "ace_eligible", "label": "ACE Eligible"},
	{ "value": "saas_revenue_recognition_id", "label": "SaaS Revenue Recognition"},
	{ "value": "saas_revenue_recognition", "label": "SaaS Revenue Recognition", onlyForDisplay: true},
	{ "value": "aws_marketplace_status_id", "label": "AWS Marketplace Status"},
	{ "value": "marketplace_status", "label": "Marketplace Status", onlyForDisplay: true},
	{ "value": "engaged_greenfield", "label": "Engaged\\Greenfield"},
	{ "value": "aws_relationship_strength_id", "label": "AWS Relationship Strength"},
	{ "value": "aws_relationship_strength", "label": "AWS Relationship Strength", onlyForDisplay: true},
	{ "value": "aws_main_contact_id", "label": "AWS Main Contacts"},
	{ "value": "aws_main_contacts", "label": "AWS Main Contacts", onlyForDisplay: true},
	{ "value": "aws_services", "label": "AWS Services"},
	{ "value": "aws_adoption_id", "label": "AWS Adoption"},
	{ "value": "aws_adoption", "label": "AWS Adoption", onlyForDisplay: true},
	{ "value": "aws_code", "label": "AWS Code"},
	{ "value": "fortune_num", "label": "Fortune Num"},
	{ "value": "initial_source", "label": "Initial Source"},
	{ "value": "duns_num", "label": "Duns Num"},
	{ "value": "industry_id", "label": "Industry"},
	{ "value": "industry", "label": "Industry", onlyForDisplay: true},
	{ "value": "is_priority", "label": "Priority"},
	{ "value": "employees", "label": "Company size"},
	{ "value": "latest_source", "label": "Latest source", onlyForDisplay: true},
];

const msAccountFields = [
	{ "value": "account_name", "label": "Account Name", onlyForDisplay: true},
	{ "value": "ms_account_name", "label": "Account Name", requiredForInsert: true},
	{ "value": "hq_id", "label": "HQ", requiredForInsert: true},
	{ "value": "hq", "label": "HQ", onlyForDisplay: true},
	{ "value": "subsidiaries", "label": "Subsidiaries"},
	{ "value": "address", "label": "Address"},
	{ "value": "employees", "label": "Employees"},
	{ "value": "linkedin_followers", "label": "LinkedIn Followers"},
	{ "value": "account_description", "label": "Account Description"},
	{ "value": "specialties", "label": "Specialties"},
	{ "value": "organization_type_id", "label": "Organization Type"},
	{ "value": "organization_type", "label": "Organization Type", onlyForDisplay: true},
	{ "value": "website", "label": "Website"},
	{ "value": "crunchbase_url", "label": "Crunchbase URL"},
	{ "value": "founded", "label": "Founded"},
	{ "value": "company_linkedin_id", "label": "Company LinkedIn ID"},
	{ "value": "city", "label": "City"},
	{ "value": "state_id", "label": "State"},
	{ "value": "state", "label": "State", onlyForDisplay: true},
	{ "value": "linkedin_url", "label": "LinkedIn URL"},
	{ "value": "logo", "label": "Logo"},
	{ "value": "similar_accounts", "label": "Similar Accounts"},
	{ "value": "updates", "label": "Updates"},
	{ "value": "slogan", "label": "Slogan"},
	{ "value": "affiliates", "label": "Affiliates"},
	{ "value": "funding", "label": "Funding"},
	{ "value": "investors", "label": "Investors"},
	{ "value": "us_district_id", "label": "US District"},
	{ "value": "us_district", "label": "US District", onlyForDisplay: true},
	{ "value": "ms_subsidiary_id", "label": "Microsoft subsidiary"},
	{ "value": "microsoft_segment_group_id", "label": "Microsoft Segment Group"},
	{ "value": "microsoft_segment_group", "label": "Microsoft Segment Group", onlyForDisplay: true},
	{ "value": "microsoft_sub_segment", "label": "Microsoft Sub-Segment", onlyForDisplay: true},
	{ "value": "microsoft_subsegment_id", "label": "Microsoft Sub-Segment"},
	{ "value": "microsoft_partner_id", "label": "Microsoft Partner"},
	{ "value": "partner_type", "label": "Partner Type", onlyForDisplay: true},
	{ "value": "ip_cosell_id", "label": "IP Co-Sell"},
	{ "value": "ip_cosell", "label": "IP Co-Sell", onlyForDisplay: true},
	{ "value": "pr-acr_id", "label": "PR-ACR"},
	{ "value": "pr-acr", "label": "PR-ACR", onlyForDisplay: true},
	{ "value": "top-tier_id", "label": "Top-Tier"},
	{ "value": "top-tier", "label": "Top-Tier", onlyForDisplay: true},
	{ "value": "microsoft_marketplace_status_id", "label": "Microsoft Marketplace Status"},
	{ "value": "marketplace_status", "label": "Marketplace Status", onlyForDisplay: true},
	{ "value": "macc_eligible_id", "label": "MACC Eligible"},
	{ "value": "macc_eligible", "label": "MACC Eligible", onlyForDisplay: true},
	{ "value": "azure_adoption_id", "label": "Azure Adoption"},
	{ "value": "azure_adoption", "label": "Azure Adoption",	onlyForDisplay: true},
	{ "value": "microsoft_relationship_strength_id", "label": "Microsoft Relationship Strength"},
	{ "value": "microsoft_relationship_strength", "label": "Microsoft Relationship Strength",	onlyForDisplay: true},
	{ "value": "microsoft_main_contact_id", "label": "Microsoft Main Contacts"},
	{ "value": "microsoft_main_contacts", "label": "Microsoft Main Contacts", onlyForDisplay: true},
	{ "value": "microsoft_services", "label": "Microsoft Services"},
	{ "value": "decision_making", "label": "Decision Making"},
	{ "value": "presence", "label": "Presence"},
	{ "value": "installed_isv_technologies", "label": "Installed ISV Technologies"},
	{ "value": "installed_enterprise_technologies", "label": "Installed Enterprise Technologies"},
	{ "value": "installed_infra_providers", "label": "Installed Infra Providers"},
	{ "value": "installed_developer_tools", "label": "Installed Developer Tools"},
	{ "value": "microsoft_tags", "label": "Microsoft Tags"},
	{ "value": "initial_source", "label": "Initial Source"},
	{ "value": "fortune_num", "label": "Fortune Num"},
	{ "value": "duns_num", "label": "Duns Num"},
	{ "value": "industry_id", "label": "Industry"},
	{ "value": "industry", "label": "Industry", onlyForDisplay: true},
	{ "value": "latest_source", "label": "Latest source", onlyForDisplay: true},
	{ "value": "region_id", "label": "Region"}
];


const contactFields = [
	{ "value": "contact_name", "label": "Contact Name", requiredForInsert: true},
	{ "value": "account_id", "label": "Account Name", requiredForInsert: true},
	{ "value": "account_name", "label": "Account Name", onlyForDisplay: true},
	{ "value": "title", "label": "Title", requiredForInsert: true},
	{ "value": "contact_email", "label": "Contact Email"},
	{ "value": "contact_group_id", "label": "Group"},
	{ "value": "contact_group", "label": "Group", onlyForDisplay: true},
	{ "value": "role_category_id", "label": "Role Category"},
	{ "value": "role_category", "label": "Role Category", onlyForDisplay: true},
	{ "value": "specialty_area_id", "label": "Specialty Area"},
	{ "value": "specialty_area", "label": "Specialty Area", onlyForDisplay: true},
	{ "value": "segment_id", "label": "Segment"},
	{ "value": "segment", "label": "Segment", onlyForDisplay: true},
	{ "value": "contact_classification_id", "label": "Contact Classification"},
	{ "value": "contact_classification", "label": "Contact Classification", onlyForDisplay: true},
	{ "value": "seniority_level_id", "label": "Seniority Level"},
	{ "value": "seniority_level", "label": "Seniority Level", onlyForDisplay: true},
	{ "value": "accounts_type_id", "label": "Accounts Type"},
	{ "value": "accounts_type_name", "label": "Accounts Type", onlyForDisplay: true},
	{ "value": "num_of_managed_accounts", "label": "# of Managed Accounts"},
	{ "value": "report_to_id", "label": "Reports to"},
	{ "value": "reports_to", "label": "Reports to", onlyForDisplay: true},
	{ "value": "num_of_reportees", "label": "# of Reportees"},
	{ "value": "personal_strength_id", "label": "Personal Strength"},
	{ "value": "personal_strength", "label": "Personal Strength", onlyForDisplay: true},
	{ "value": "co-sell_willingness_id", "label": "Co-Sell Willingness"},
	{ "value": "co-sell_willingness", "label": "Co-Sell Willingness", onlyForDisplay: true},
	{ "value": "time_in_company", "label": "Time in Company"},
	{ "value": "time_in_current_role", "label": "Time in Current Role"},
	{ "value": "previous_roles", "label": "Previous Roles"},
	{ "value": "image", "label": "Image"},
	{ "value": "region_id", "label": "Region"},
	{ "value": "region", "label": "Region", onlyForDisplay: true},
	{ "value": "subsidiary_id", "label": "Subsidiary"},
	{ "value": "subsidiary", "label": "Subsidiary", onlyForDisplay: true},
	{ "value": "city", "label": "City"},
	{ "value": "us_district_id", "label": "US District"},
	{ "value": "us_district", "label": "US District", onlyForDisplay: true},
	{ "value": "area_of_interest_id", "label": "Area of Interest"},
	{ "value": "area_of_interest", "label": "Area of Interest", onlyForDisplay: true},
	{ "value": "industry_of_focus_id", "label": "Industry of Focus"},
	{ "value": "industry_of_focus", "label": "Industry of Focus", onlyForDisplay: true},
	{ "value": "tags", "label": "Tags"},
	{ "value": "description", "label": "Description"},
	{ "value": "initial_source", "label": "Initial Source"},
	{ "value": "latest_source", "label": "Latest source"},
	{ "value": "timestamp", "label": "Timestamp"}
];

const relationFields = [
	// { "value": "account_id", "label": "Account Id", requiredForInsert: true},
	// { "value": "account_name", "label": "Account Name", requiredForInsert: true},
	// { "value": "contact_id", "label": "Contact Id", requiredForInsert: true},
	// { "value": "contact_email", "label": "Contact Email", requiredForInsert: true},
	{ "value": "account_id", "label": "Account Name", requiredForInsert: true},
	{ "value": "contact_id", "label": "Contact Email", requiredForInsert: true},
	{ "value": "role", "label": "Role", requiredForInsert: true},
	{ "value": "main_contact_id", "label": "Main Contact"},
	{ "value": "relationship_strength_id", "label": "Relationship strength"},
	{ "value": "relationship_description", "label": "Relationship Description"},
	{ "value": "start_date", "label": "Start Date"},
	{ "value": "end_date", "label": "End Date"},
	{ "value": "direct", "label": "Direct"},
	{ "value": "active", "label": "Active"},
	{ "value": "initial_source", "label": "Initial Source"},
	{ "value": "timestamp", "label": "Timestamp"},
	{ "value": "latest_source", "label": "Latest source"},
	{ "value": "timestamp", "label": "Timestamp"}
];

export const getObjectFields = (cloud, objName) => {
	let fields;
	if(objName === 'accounts') {
		fields = cloud === 'aws' ? [...awsAccountFields] : [...msAccountFields];
	}
	else if(objName === 'contacts') {
		fields = [...contactFields];
	}
	else if(objName === 'relations') {
		fields = [...relationFields];
	}

	fields.unshift({ "value": "ignore", "label": "Ignore this column"});
	return fields;
};
